/**
 * Configure requirejs dependencies.
 */
requirejs.config({
    paths: {
        jquery: '../lib/jquery/jquery.min',
        "js-cookie": '../lib/js-cookie/js.cookie',
        jqueryRotate: 'jQueryRotate',
        bootstrap: '../lib/bootstrap/js/bootstrap.min',
        mustache: '../lib/mustachejs/mustache'
    },
    shim: {
        "jquery": {
            "exports": "$"
        },
        bootstrap: {
            deps: ['jquery']
        },
        jqueryRotate: {
            deps: ['jquery']
        }
    }
});

define('main',['jquery', 'mustache', 'bootstrap', 'domReady!'], function ($, mustache) {
    "use strict";

    /**
     * expose an IE save console logger
     */
    function log() {
        if (window.gewinnspiel && window.gewinnspiel.debug && window.console) {
            window.console.log.apply(window, arguments);
        }
    }

    log('initializing main module ...');

    /**
     * Confirm dialog.
     */
    function confirmDialog(actionUrl, actionLabel, title, content, showCancel, loadedCallback) {
        window.jsRoutes.controllers.Assets.versioned("templates/confirm-dialog.html").ajax().done(function (data) {
            $("body").append(mustache.render(data, {
                title: title,
                body: content,
                actionLabel: actionLabel,
                actionUrl: actionUrl,
                cancel: showCancel
            }));

            var $modal = $(".modal");
            $modal.modal({
                backdrop: "static",
                show: true
            });

            // remove from dom, when dismissed
            $modal.on('hidden.bs.modal', function () {
                $modal.remove();
            });

            if (loadedCallback !== undefined) {
                loadedCallback();
            }

        }).fail(function (ignore, statusText, error) {
            log("error status text", statusText);
            log("error", error);
        });
    }

    /**
     * Generic modal dialog.
     */
    function genericDialog(title, content, loadedCallback) {
        window.jsRoutes.controllers.Assets.versioned("templates/generic-dialog.html").ajax().done(function (data) {
            $("body").append(mustache.render(data, {
                title: title,
                body: content
            }));

            var $modal = $(".modal");
            $modal.modal({
                backdrop: "static",
                show: true
            });

            // remove from dom, when dismissed
            $modal.on('hidden.bs.modal', function () {
                $modal.remove();
            });

            if (loadedCallback !== undefined) {
                loadedCallback();
            }

        }).fail(function (ignore, statusText, error) {
            log("error status text", statusText);
            log("error", error);
        });
    }

    /**
     * Detect IE Browsers.
     * @returns {string|boolean} IE version or false if its not an IE
     * @constructor
     * @see https://www.w3docs.com/snippets/javascript/how-to-detect-internet-explorer-in-javascript.html
     */
    function IEdetection() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older, return version number
            return ('IE ' + parseInt(ua.substring(
                msie + 5, ua.indexOf('.', msie)), 10));
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11, return version number
            var rv = ua.indexOf('rv:');
            return ('IE ' + parseInt(ua.substring(
                rv + 3, ua.indexOf('.', rv)), 10));
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            //Edge (IE 12+), return version number
            return ('IE ' + parseInt(ua.substring(
                edge + 5, ua.indexOf('.', edge)), 10));
        }
        // User uses other browser
        return false;
    }


    // new login overlay component
    var $oeamtcLogin = document.getElementsByTagName('oeamtc-login').item(0);
    if ($oeamtcLogin) {
        var isLogin = false;

        // login success event
        $oeamtcLogin.addEventListener('login-success', function (event) {
            if (event.detail) {
                if (isLogin) {
                    $oeamtcLogin.setAttribute('display-component', JSON.stringify(false));
                    isLogin = false;
                    window.location.reload();
                }
            }
        });

        // login cancel event
        $oeamtcLogin.addEventListener('login-cancel', function () {
            $oeamtcLogin.setAttribute('display-component', JSON.stringify(false));
            window.location.reload();
        });

        /**
         * Show login modal.
         */
        var $loginLink = $('.login-trigger');
        $loginLink.click(function (event) {
            isLogin = true;
            $oeamtcLogin.setAttribute('display-component', JSON.stringify(true));
            event.preventDefault();
            return false;
        });
    }

    /**
     *  Enable tooltips.
     */
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="dropdown"]').dropdown();

    /**
     * Enable popovers.
     * HTML content can be provided via the 'rel' attribute.
     */
    $('[data-toggle="popover"]').each(function () {
        var $this = $(this);
        var options = {};

        var contentSelector = $this.attr('rel');
        if (typeof contentSelector !== typeof undefined && $(contentSelector).length > 0) {
            options.html = true;
            options.content = function () {
                return $(contentSelector).html();
            };
        }

        $this.popover(options);
    });

    /**
     * One popover at a time - disable multiple popover
     * @see https://stackoverflow.com/questions/11703093/how-to-dismiss-a-twitter-bootstrap-popover-by-clicking-outside
     */
    $(document).on('click', function (e) {
        $('[data-toggle="popover"],[data-original-title]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false;  // fix for BS 3.3.6
            }
        });
    });

    /**
     * Enable gallery for price pictures.
     */
    $(".price-gallery").each(function(e) {
        var $gallery = $(this);
        var $image = $gallery.find(".price-gallery__image");
        var $thumbnails = $gallery.find(".price-gallery__thumbnail");
        $thumbnails.on('click', function (event){
            event.preventDefault();
            var $thumbnail = $(this);
            $thumbnails.removeClass("price-gallery__thumbnail--active");
            $thumbnail.addClass("price-gallery__thumbnail--active");
            $image.attr("src", $thumbnail.attr("href"));
        });
    });

    return {
        log: log,
        confirmDialog: confirmDialog,
        genericDialog: genericDialog,
        IEdetection: IEdetection
    };
});

requirejs.onError = function (err) {
    "use strict";
    if (window.gewinnspiel && window.gewinnspiel.debug && window.console) {
        window.console.log(err);
    }
};

